/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const deleteNotificationPolicyBodyExpectedVersionExclusiveMin = 0;
export const deleteNotificationPolicyBodyExpectedVersionMax = 9007199254740991;

export const DeleteNotificationPolicyBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(deleteNotificationPolicyBodyExpectedVersionExclusiveMin)
    .max(deleteNotificationPolicyBodyExpectedVersionMax),
});

export type DeleteNotificationPolicyBody = zod.input<typeof DeleteNotificationPolicyBody>;
export type DeleteNotificationPolicyBodyOutput = zod.output<typeof DeleteNotificationPolicyBody>;
